export default function createHeaderPalette(theme, current, base) {
    return {
        header: {
            divider: {
                borderColor: base.gray[200],
            },
            header: {
                backgroundColor: base.background,
            },
            toggle: {
                color: current[500],
                backgroundColor: "transparent",
                hover: {
                    color: current[400],
                },
                active: {
                    color: current[600],
                },
            },
        },
    };
}
//# sourceMappingURL=header.js.map